import * as React from "react";
import {Outlet, useLocation, useSearchParams} from "react-router-dom";
import Header from "../Header/Header";
import Topbar from "../Topbar/Topbar";
import IdleTimerConatiner from "components/IdleTimer/IdleTimerConatiner";
import {useAppSelector, useAppDispatch, store} from "../../redux/store";
import SidebarNav from "components/Sidebar/SidebarNav";
import {clearAuthState} from "../../redux/reducers/authSlice";
import type {menu, subMenu} from "../../redux/reducers/authSlice";
import {switchApplication} from "commonUtils/switchApplication";
import {PageNames} from "commonUtils/enumerations";
import {loggedMessage} from "commonUtils/utils";

const styleMap = new Map([
  ["Dashboard", "main-active"],
  ["Faculty", ""],
  ["Activity", ""],
  ["Reports", ""],
  ["Evaluation", ""],
  ["Alerts", ""],
  ["Resources", ""],
  ["Administration", ""],
]);

const MasterLayout: React.FC = () => {
  const [params, setParams] = React.useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [searchParam, setSearchParam] = useSearchParams();
  const searchParams = new URLSearchParams(window.location.search);
  if (
    searchParams.has("userIdentity") &&
    searchParams.has("userId") &&
    !params
  ) {
    setParams(true);
    dispatch(clearAuthState());
    switchApplication(window.location.search, window.location.pathname);
  }
  const menus = useAppSelector(state => {
    return state?.auth?.userPreferences?.menus;
  });
  const shouldLoad = menus;
  const [subPages, setSubPages] = React.useState<subMenu[]>([]);
  const location = useLocation();
  const pathName = location.pathname;
  const SelectedTopMenu = pathName.slice(1, pathName.length);
  const regex = /[^/]+/;
  const match = SelectedTopMenu.match(regex);
  const ADMIN_ID = 8;

  const getSubmenus = () => {
    const array = menus?.map((item: menu) => {
      return item;
    });
    const filteredSelectMenu = array?.filter((ar: menu) => {
      return ar.id === ADMIN_ID
        ? match?.[0]?.includes(ar.displayText.toLowerCase())
        : ar.displayText.toLowerCase() === match?.[0]?.toLowerCase();
    });

    const filteredSelectedMenu = array?.filter((ar: menu) => {
      return ar.displayText.toLowerCase() === SelectedTopMenu.toLowerCase();
    });
    if (filteredSelectedMenu?.length === 0) {
      return filteredSelectMenu?.[0]?.subMenus;
    } else {
      return filteredSelectedMenu?.[0]?.subMenus;
    }
  };
  const updateStyleMap = (key: string) => {
    const currentSelectedMenu = key.split("/")[0];
    for (const entry of styleMap) {
      if (entry[0] === currentSelectedMenu) {
        styleMap.set(entry[0], "main-active");
      } else {
        styleMap.set(entry[0], "");
      }
    }
  };
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  React.useEffect(() => {
    try {
      if (searchParam.has("userIdentity")) {
        searchParam.delete("userIdentity");
      }
      if (searchParam.has("userId")) {
        searchParam.delete("userId");
      }
      if (searchParam.has("profileId")) {
        searchParam.delete("profileId");
      }
      if (searchParam.has("userName")) {
        searchParam.delete("userName");
      }
      if (searchParam.has("switchedUserId")) {
        searchParam.delete("switchedUserId");
      }
      if (searchParam.has("switchedProfileId")) {
        searchParam.delete("switchedProfileId");
      }
      if (searchParam.has("switchedUserName")) {
        searchParam.delete("switchedUserName");
      }
      if (searchParam.has("token")) {
        searchParam.delete("token");
      }
      if (searchParam.has("llyReadOnlyUser")) {
        searchParam.delete("llyReadOnlyUser");
      }
      if (searchParam.has("supplierId")) {
        searchParam.delete("supplierId");
      }
      if (searchParam.has("userTypeId")) {
        searchParam.delete("userTypeId");
      }
      setSearchParam(searchParam, {replace: true});
      const authState = store.getState();
      if (!authState.auth?.authDetails?.isAuthenticated) {
        window.location.href = "/";
      }
    } catch (error: any) {
      loggedMessage(error, "", PageNames.MASTER_LAYOUT);
    }
  }, []);

  React.useEffect(() => {
    const subMenus = getSubmenus();
    setSubPages(subMenus);
  }, [location, shouldLoad]);

  React.useEffect(() => {
    const currentSelectedMenu = location.pathname;
    updateStyleMap(
      capitalizeFirstLetter(
        currentSelectedMenu.slice(1, currentSelectedMenu.length),
      ),
    );
  }, [location]);

  return (
    <>
      <Header />
      <Topbar styleMap={styleMap} />
      <div className="container">
        {subPages?.length > 0 && <SidebarNav subPages={subPages} />}
        <main className="main-content">
          <div className="main-container">
            <IdleTimerConatiner />
            <Outlet />
          </div>
          {/* <Footer /> */}
        </main>
      </div>
    </>
  );
};

export default MasterLayout;
